/**
 * Login / navigation targets per platform. Kept in a small module so it always
 * initializes reliably (avoid importing from the large constants bundle).
 */
export type LoginPlatform = "facebook" | "instagram";

// Change this value to switch app login/navigation between platforms.
export const LOGIN_PLATFORM: LoginPlatform = "facebook";

export const LOGIN_ROUTES = {
  facebook: {
    dashboard: "/dashboard",
    connect: "/connect",
    auth: "/success",
  },
  instagram: {
    dashboard: "/instagram-dashboard",
    connect: "/instagram-connect",
    auth: "/instagram-auth",
  },
} as const;

const fallback = LOGIN_ROUTES.facebook;

export const ACTIVE_LOGIN_ROUTES =
  LOGIN_ROUTES[LOGIN_PLATFORM] ?? fallback;
